module.exports = __webpack_public_path__ + "static/InputField_text-input-fcdf67ffad438556aedf55da04206372.png";